import { render, staticRenderFns } from "./Reviewer.vue?vue&type=template&id=7be98f88&"
import script from "./Reviewer.vue?vue&type=script&lang=js&"
export * from "./Reviewer.vue?vue&type=script&lang=js&"
import style0 from "./Reviewer.vue?vue&type=style&index=0&id=7be98f88&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports